import { Component, Vue } from 'vue-property-decorator';
import store from '@/store'

@Component
export default class CRUDMixins extends Vue {

  unsubscribe: () => void | null = () => {
    // Placeholder
  }

  created() {
    this.unsubscribe = store.subscribe((mutation) => {
      if (mutation.type === 'CALL_ACTION') {
        switch (mutation.payload) {
          case 'CREATE':
            this.create()
            break
          case 'UPDATE':
            this.update()
            break
          case 'READ':
            this.read()
            break
          case 'DELETE':
            this.delete()
            break
          default:
            console.error('Undefined method: ' + mutation.payload)
            break
        }
      }
    })
  }

  beforeDestroy() {
    this.unsubscribe()
  }

  create(any?) {
    console.error('Create method is missing.')
  }

  update(any?) {
    console.error('Update method is missing.')
  }

  read(any?) {
    console.error('Read method is missing.')
  }

  delete(any?) {
    console.error('Delete method is missing.')
  }
}